/**
 * exhbt.ts
 * [Readme] --------------------------------------------------------------------------------------
 *
 * 사이버주택전시관의 링크 데이터와 이미지, 텍스트를 설정할 수 있습니다.
 *
 * -----------------------------------------------------------------------------------------------
 */

import { EndPointURL } from 'common-modules/general/Config/constants';
import { cdBizLnd } from './configs';

import imglist from 'assets/Desktop/images/common/brand_htco_visual02.jpg';
import imglist1 from 'assets/Desktop/images/parcelOut/cyber_thum01.jpg';
import imglist2 from 'assets/Desktop/images/parcelOut/cyber_thum02.jpg';
import imglist3 from 'assets/Desktop/images/parcelOut/cyber_thum03.jpg';

/**
 * 사이버 주택 전시관에서 사용되는 정보입니다.
 * 해당 정보를 추가하면 자동으로 리스트 형태로 표출됩니다.
 * 이미지의 경우 권장 사이즈는 800*415(px)입니다. Ratio : 1.92
 * 
 * 아래 내용은 타입으로 분류됩니다.
 * img : 리스트에 표출할 이미지입니다.
 * tit : 타이틀(굵은 글씨) 입니다.
 * subtit : 하단의 서브타이틀 입니다.
 * type : 'vr' 과 'movie'로 나뉩니다. vr은 사이버주택전시관 VR, movie는 동영상(Vimeo 버전) 입니다.
 * desktop: 데스크탑 사이드의 링크입니다. (주로 VR 링크가 데스크탑, 모바일이 달라 분리 했습니다.)
 * mobile: 모바일 사이드의 링크입니다. (주로 VR 링크가 데스크탑, 모바일이 달라 분리 했습니다.)
 */
export const exhbtListContent = [
  {
    img: imglist,
    tit: 'VR 세대 관람하기',
    subtit: '세대 내부를 VR 투어로 감상할 수 있습니다.',
    type: 'vr',
    desktop: `http://vrweb.kr/gumi/index.html`,
    mobile: `http://vrweb.kr/gumi/index.html`
  },

  /**
   * ※ 아래는 동영상 등록 샘플
   */
  // {
  //   img: imglist1,
  //   tit: 'e편한세상 구미상모 트리베뉴 입지단지 영상',
  //   subtit: '금오산을 품은 직주근접 라이프, 구미의 특별한 자부심이 되다.',
  //   type: 'movie',
  //   desktop: `https://player.vimeo.com/video/755143690?h=43c1dff575?h=7a79ffb22e&autoplay=1`,
  //   mobile: `https://player.vimeo.com/video/755143690?h=43c1dff575`
  // },
  // {
  //   img: imglist2,
  //   tit: '84B 유니트 둘러보기',
  //   subtit: '유니트 내부를 관람할 수 있습니다.',
  //   type: 'movie',
  //   desktop: `https://player.vimeo.com/video/764371119?h=7a79ffb22e&autoplay=1`,
  //   mobile: `https://player.vimeo.com/video/764371119?h=7a79ffb22e`
  // },
  // {
  //   img: imglist3,
  //   tit: '116 유니트 둘러보기',
  //   subtit: '유니트 내부를 관람할 수 있습니다.',
  //   type: 'movie',
  //   desktop: `https://player.vimeo.com/video/764370290?h=7a79ffb22e&autoplay=1`,
  //   mobile: `https://player.vimeo.com/video/764370290?h=7a79ffb22e`
  // }
];
